export default data => {
    return {
        type: 'TOGGLE_UNREAD_CHATS',
        data
    };
};
